<script setup lang="ts">
  import { type HTMLAttributes, computed } from 'vue'
  import { ProgressIndicator, ProgressRoot, type ProgressRootProps } from 'radix-vue'
  import { cn } from '@/lib/utils'

  const props = withDefaults(
    defineProps<ProgressRootProps & { class?: HTMLAttributes['class']; indeterminate?: boolean }>(),
    {
      modelValue: 0,
      indeterminate: false
    }
  )

  const delegatedProps = computed(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { class: _, ...delegated } = props

    return delegated
  })
</script>

<template>
  <ProgressRoot
    v-bind="delegatedProps"
    :class="
      cn(
        'relative h-4 w-full overflow-hidden rounded-full bg-secondary',
        { 'progress-indeterminate': props.indeterminate },
        props.class
      )
    "
  >
    <ProgressIndicator
      :class="[
        'h-full',
        'transition-all',
        props.indeterminate ? 'bg-purple-600' : 'flex-1 bg-purple-600'
      ]"
      :style="
        props.indeterminate
          ? 'width: 50%;'
          : `transform: translateX(-${100 - (props.modelValue ?? 0)}%)`
      "
    />
  </ProgressRoot>
</template>

<style scoped>
  @keyframes indeterminate {
    0% {
      transform: translateX(-100%);
    }

    100% {
      transform: translateX(100%);
    }
  }

  .progress-indeterminate .progress-indicator {
    animation: indeterminate 2s linear infinite;
  }
</style>
